import { createContext } from 'react';
/** @private Internal context. Do not use in your production. */
const SliderInternalContext = /*#__PURE__*/createContext({});
export default SliderInternalContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/slider/Context.js
// module id = 777
// module chunks = 0